import { useState } from 'react'

export const useForm = (formFields) => {

  const [trigger, setTrigger] = useState(false)
  const [fields, setFields] = useState({ ...formFields })

  const formIsValid = () => {
    //console.log('==================')
    return Object.keys(fields).every((name) => {
      const field = fields[name]
      
      //console.log(name, field)
      if (!field.validate) {
        //console.log('true')
        return true
      }
      if (!field.valid_reg) {
        //console.log(field.valid_reg)
        return field.valid_reg
      }
      if (field.valid_reg && field.valid)  {
        //console.log('true')
        return true
      }
      //console.log(field.valid)
      return field.valid
    })
  }

  const setFieldValid = (name, valid, valid_reg) => {
    //console.log(name + ' ' + valid + ' ' + valid_reg)
    setFields({ ...fields, [name]: { ...fields[name], valid, valid_reg } })
  }

  const setValue = (ev) => {
    const { name, value } = ev.target
    let nname = name ? name : ev
    setFields({ ...fields, [nname]: { ...fields[nname], value } })
  }

  const setAddress = (data, isChange) => {
    const { value } = data
    setFields({ ...fields, 'city': { ...fields['city'], value: value, valid: !isChange, valid_reg: !isChange} })
  }

  const setInn = (data, isChange) => {   
    console.log(data, isChange)
    const value = isChange ? data?.value : data?.data?.inn
    console.log(value)
    setFields({ ...fields, 'inn': { ...fields['inn'], value: value, valid: !isChange, valid_reg: !isChange}, 'legalName': { ...fields['legalName'], value: isChange ? '' : data?.value, valid: true, valid_reg: true} })

  }

  const setValidate = (name, validate) => {
    //console.log({ ...fields, [name]: { ...fields[name], validate: validate } })
    setFields({ ...fields, [name]: { ...fields[name], validate: validate } })
  }

  const setCheckValue = (name, value, valid, valid_reg) => {

    if(name === 'legalType') {
      setFields({ ...fields, [name]: { ...fields[name], value, valid, valid_reg }, 'inn': { ...fields['inn'], value: '', valid: false, valid_reg: false, validate: value === 'ООО' ? 'inn_ur' : 'inn_fiz'} })
    } else {
      setFields({ ...fields, [name]: { ...fields[name], value, valid, valid_reg } })
    }
  }

  const setValueSelect = (name, value, valid, valid_reg) => {
    //console.log({ [name]: { ...fields[name], value: value, valid: valid, valid_reg: valid_reg } })
    setFields({ ...fields, [name]: { ...fields[name], value: value, valid: valid, valid_reg: valid_reg } })
  }

  const clearForm = () => {
    //console.log({ ...formFields })
    setFields({ ...formFields })
    setTrigger(false)
  }

  return [fields, setValue, setFieldValid, formIsValid, trigger, setTrigger, setValidate, setCheckValue, setAddress, setInn, setValueSelect, clearForm, ]

}


